var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7742 0H11.2258C5.02596 0 0 5.02596 0 11.2258V46.7742C0 52.974 5.02596 58 11.2258 58H46.7742C52.974 58 58 52.974 58 46.7742V11.2258C58 5.02596 52.974 0 46.7742 0Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7742 0H11.2258C5.02596 0 0 5.02596 0 11.2258V46.7742C0 52.974 5.02596 58 11.2258 58H46.7742C52.974 58 58 52.974 58 46.7742V11.2258C58 5.02596 52.974 0 46.7742 0Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 28.7635C31.2 30.0044 30.2152 31.0097 29 31.0097C27.7848 31.0097 26.8 30.0044 26.8 28.7635V0H18V28.7635C18 34.9689 22.9245 40 29 40C35.0747 40 40 34.9689 40 28.7635V0H31.2V28.7635Z",
    fill: "#0F1014"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29,
    y1: 0,
    x2: 29,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED20F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a41b2a71.svg";
export { ForwardRef as ReactComponent };